module.exports = __webpack_public_path__ + "media/recipes/11-e057bbb1.png";